var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFamilyTree(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 45.76,
    viewBox: "0 0 50 45.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(-152 -387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M26.791,40.279V36.827H13.672V33.5",
    transform: "translate(150.092 382.326)",
    fill: "none",
    stroke: "#ccc",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M28.919,36.827H42.413V33.5",
    transform: "translate(147.964 382.326)",
    fill: "none",
    stroke: "#ccc",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M43.294,19.231V15.779H36.57V12.2",
    transform: "translate(146.896 385.297)",
    fill: "none",
    stroke: "#ccc",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M44.384,15.779h7.1V12.2",
    transform: "translate(145.806 385.297)",
    fill: "none",
    stroke: "#ccc",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M12.324,19.231V15.779H5.357V12.2",
    transform: "translate(151.252 385.297)",
    fill: "none",
    stroke: "#ccc",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M13.454,15.779H20.8V12.2",
    transform: "translate(150.122 385.297)",
    fill: "none",
    stroke: "#ccc",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M23.443,46.942a4.712,4.712,0,1,1,4.712,4.712,4.712,4.712,0,0,1-4.712-4.712",
    transform: "translate(148.728 381.107)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M39.126,26.123a4.712,4.712,0,1,1,4.712,4.712,4.712,4.712,0,0,1-4.712-4.712",
    transform: "translate(146.54 384.012)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M8.2,26.123a4.712,4.712,0,1,1,4.712,4.712A4.712,4.712,0,0,1,8.2,26.123",
    transform: "translate(150.856 384.012)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M0,4.712A4.712,4.712,0,1,1,4.712,9.424,4.712,4.712,0,0,1,0,4.712",
    transform: "translate(152 387)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M16.512,4.712a4.712,4.712,0,1,1,4.712,4.712,4.712,4.712,0,0,1-4.712-4.712",
    transform: "translate(149.696 387)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M31.094,4.712a4.712,4.712,0,1,1,4.712,4.712,4.712,4.712,0,0,1-4.712-4.712",
    transform: "translate(147.661 387)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M47.158,4.712A4.712,4.712,0,1,1,51.87,9.424a4.712,4.712,0,0,1-4.712-4.712",
    transform: "translate(145.419 387)",
    fill: "#ccc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyTree);
export default __webpack_public_path__ + "static/media/family_tree.08b4a17d0d1531a581246eb354e9e418.svg";
export { ForwardRef as ReactComponent };